<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import RouterTabs from './components/RouterTabs.vue';

const { t } = useI18n();

const tabPanel = [
  {
    path: '/law/licence',
    label: t('law.licence.title1'),
  },
  {
    path: '/law/translation',
    label: t('law.translation.title1'),
  },
  {
    path: '/law/lecture',
    label: t('law.lectures.title1'),
  },
  {
    path: '/law/salon',
    label: t('law.salon.title1'),
  },
  {
    path: '/law/database',
    label: t('law.database.title'),
  },
];
</script>

<template>
  <main class="page-law bg-white pb-[160px] <md:pb-80">
    <section class="page-law-banner h-[406px] w-full <md:h-240 <md:flex <md:items-center">
      <div class="container mx-auto pt-[146px] text-[#2d2d2d] <md:py-0 <sm:px-16 <xl:px-24">
        <h1 class="mt-0 h-70px text-[50px] font-medium leading-70px <md:h-auto <md:text-32 <md:leading-44">{{ t('header.nav5.children.nav3') }}</h1>
      </div>
    </section>

    <RouterTabs :item-list="tabPanel" :default-title="t('header.nav5.children.nav3')" />
  </main>
</template>

<style lang="scss" scoped>
.page-law {
  .page-law-banner {
    background: url(@/assets/law/banner-bg.png) no-repeat;
    background-position: center;
    background-size: cover;
  }

  @media (max-width: 767.9px) {
    .page-law-banner {
      text-align: center;
      background: linear-gradient(160deg, #eaf2ff, #f5f7fa);
    }
  }
}
</style>
